import styleMinesQuarries from './MinesQuarries.module.css';
import { useContext, useEffect, useState } from 'react';
import { TaxDeclartionContext } from '../../../contexts/TaxDeclaration';
import InputElement from '../../../shared/form/InputElement';
import { getDeclarationCurencies } from '../../../adapters/apis/lookups/lookups';
import DatePicker, { registerLocale } from "react-datepicker";
import ar from "date-fns/locale/ar"; // the locale you want
import SearchSelectElement from '../../../shared/form/SearchSelectElement';
registerLocale("ar", ar); // register it with the name you want

function MinesQuarries(props) {

  const taxContext = useContext(TaxDeclartionContext);
  const minesQuarriesData = taxContext.taxDeclaration.parentMinesQuarries.mainData;

  const minesQuarriesDataErrors = taxContext.formErrors.parentMinesQuarries.mainData;
  const [currencyType, setCurrencyType] = useState([]);
  const generalErrorsDraft = taxContext.generalErrorsDraft;

  useEffect(() => {
    getDeclarationCurencies().then((res) => {
      setCurrencyType(res.data.data);
    }).catch((err) => {
      console.error(err);
    });
    if (taxContext.formErrors.parentMinesQuarries.error !== "") {
      window.scrollTo(0, 0);
    }
  }, [taxContext.formErrors.parentMinesQuarries.error]);

  const currencyType_options = currencyType.map((element) => {
    return (
      { value: element.id, label: element.name }
    );
  });
  const errors_draft = generalErrorsDraft.map((element, index) => {
    return (
      <div className="alert alert-danger col-md-12" role="alert" key={ index }>
        { element }
      </div>
    );
  });
  return (
    <>
      { taxContext.formErrors.parentMinesQuarries.error !== "" &&
        <div className="alert alert-danger m-0" role="alert">
          { taxContext.formErrors.parentMinesQuarries.error }
        </div>
      }
      { generalErrorsDraft.length > 0 && !props.disabled &&
        <div className={ `${styleMinesQuarries.box} box` }>
          <div className="row">
            { errors_draft }
          </div>
        </div>
      }
      <div className={ `${styleMinesQuarries.box} box pdf-box` }>
        <h4 className={ `${styleMinesQuarries["box-title"]} box-title mb-4` }>
          المناجم و المحاجر
        </h4>
        <div className="row">
          <div className="col-md-3">
            <InputElement
              mb4='mb-4'
              labelHtmlFor='usufruct_value'
              name='usufruct_value'
              labelClassName={ ` required ${styleMinesQuarries["form-label"]} form-label` }
              labelText='قيمة الانتفاع / الاستغلال'
              inputType='text'
              max={ 999999999999999 }
              inputClassName={ `${styleMinesQuarries["form-control"]} form-control` }
              inputID='usufruct_value'
              pClassName='text-danger mb-0 mt-2 me-2 fw-bolder'
              value={ minesQuarriesData.usufruct_value }
              onChange={ taxContext.handleChange }
              pText={ minesQuarriesDataErrors.usufruct_value }
              compenent='mainData'
              parentCompenent='parentMinesQuarries'
              disabled={ props.disabled ? true : false }
            />
          </div>
          <div className="col-md-3">
            <SearchSelectElement
              mb4='mb-4'
              labelHtmlFor='usufruct_value_currency_id'
              labelClassName={ ` required form-label ${styleMinesQuarries["form-label"]}` }
              labelText='نوع العملة'
              selectClassName={ `${styleMinesQuarries["form-select"]} form-select` }
              selectID='usufruct_value_currency_id'
              name='usufruct_value_currency_id'
              options={ currencyType_options }
              default='أختار نوع العملة..'
              pClassName='text-danger mb-0 mt-2 me-2 fw-bolder'
              value={ minesQuarriesData.usufruct_value_currency_id }
              onChange={ taxContext.handleChange }
              pText={ minesQuarriesDataErrors.usufruct_value_currency_id }
              compenent='mainData'
              parentCompenent='parentMinesQuarries'
              disabled={ props.disabled ? true : false }
            />
          </div>
            { minesQuarriesData.usufruct_contract_file.full_url && taxContext.update && !props.disbaled?
              <>
              <div className="col-md-3">
              <div className='mb-4'>
                <label className='form-label'> عقد الانتفاع</label>
                <a href={ minesQuarriesData.usufruct_contract_file.full_url } target="_blank" rel="noreferrer" className='btn btn-primary d-block py-2 btn-view'> <i className="fa-solid fa-file-image fa-fw fa-lg"></i>
                  عقد الانتفاع
                </a>
              </div>
              </div>
              <div className="col-md-3">
              <InputElement
                mb4='mb-4'
                inputIcon={ `${styleMinesQuarries["input-icon"]} input-icon` }
                labelHtmlFor='usufruct_contract_file'
                labelClassName={ ` required ${styleMinesQuarries["form-label"]} form-label` }
                labelText='إرفاق عقد الانتفاع'
                inputType={ props.disabled ? 'text' : 'file' }
                inputClassName={ `${styleMinesQuarries["form-control"]} form-control` }
                inputID='usufruct_contract_file'
                name='usufruct_contract_file'
                fileName='إرفاق ملف'
                pClassName='text-danger mb-0 mt-2 me-2 fw-bolder'
                icon="fa-solid fa-cloud-arrow-up"
                pText={ minesQuarriesDataErrors.usufruct_contract_file }
                onChange={ taxContext.handleChange }
                compenent='mainData'
                parentCompenent='parentMinesQuarries'
                disabled={ props.disabled ? true : false }
                value={ minesQuarriesData.usufruct_contract_file.name }
                fileData={ minesQuarriesData.usufruct_contract_file.name }
              />
              </div>
              </>
              :minesQuarriesData.usufruct_contract_file.full_url ?
              <div className="col-md-3">
              <div className='mb-4'>
                <label className='form-label'> عقد الانتفاع</label>
                <a href={ minesQuarriesData.usufruct_contract_file.full_url } target="_blank" rel="noreferrer" className='btn btn-primary d-block py-2 btn-view'> <i className="fa-solid fa-file-image fa-fw fa-lg"></i>
                  عقد الانتفاع
                </a>
              </div>
              </div>
              :
              <div className="col-md-3">
              <InputElement
                mb4='mb-4'
                inputIcon={ `${styleMinesQuarries["input-icon"]} input-icon` }
                labelHtmlFor='usufruct_contract_file'
                labelClassName={ ` required ${styleMinesQuarries["form-label"]} form-label` }
                labelText='إرفاق عقد الانتفاع'
                inputType={ props.disabled ? 'text' : 'file' }
                inputClassName={ `${styleMinesQuarries["form-control"]} form-control` }
                inputID='usufruct_contract_file'
                name='usufruct_contract_file'
                fileName='إرفاق ملف'
                pClassName='text-danger mb-0 mt-2 me-2 fw-bolder'
                icon="fa-solid fa-cloud-arrow-up"
                pText={ minesQuarriesDataErrors.usufruct_contract_file }
                onChange={ taxContext.handleChange }
                compenent='mainData'
                parentCompenent='parentMinesQuarries'
                disabled={ props.disabled ? true : false }
                value={ minesQuarriesData.usufruct_contract_file.name }
                fileData={ minesQuarriesData.usufruct_contract_file.name }
              />
              </div>
            }
          <div className="col-md-3">
            <div className="mb-4">
              <label htmlFor="date" className={ `required ${styleMinesQuarries["form-label"]} form-label` }>تاريخ الانتفاع او الاستغلال</label>
              <DatePicker
                className={ `${styleMinesQuarries["form-control"]} form-control` }
                selected={ minesQuarriesData.date_exploitation }
                onChange={ (date) => taxContext.handleChange('parentMinesQuarries', 'mainData', 'date_exploitation', date) }
                dateFormat="MMMM yyyy"
                locale="ar"
                disabled={ props.disabled ? true : false }
                showMonthYearPicker
                showFullMonthYearPicker
              />
              { !props.disabled && minesQuarriesDataErrors.date_exploitation && <p className='text-danger mb-0 mt-2 me-2 fw-bolder'>{ minesQuarriesDataErrors.date_exploitation }</p> }

            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <label htmlFor="date" className={ `required ${styleMinesQuarries["form-label"]} form-label` }>مدة الانتفاع من</label>
              <DatePicker
                className={ `${styleMinesQuarries["form-control"]} form-control` }
                selected={ minesQuarriesData.benefit_period_from }
                onChange={ (date) => taxContext.handleChange('parentMinesQuarries', 'mainData', 'benefit_period_from', date) }
                dateFormat="MMMM yyyy"
                locale="ar"
                disabled={ props.disabled ? true : false }
                showMonthYearPicker
                showFullMonthYearPicker
              />
              { !props.disabled && minesQuarriesDataErrors.benefit_period_from && <p className='text-danger mb-0 mt-2 me-2 fw-bolder'>{ minesQuarriesDataErrors.benefit_period_from }</p> }

            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <label htmlFor="date" className={ `required ${styleMinesQuarries["form-label"]} form-label` }>مدة الانتفاع إلي</label>
              <DatePicker
                className={ `${styleMinesQuarries["form-control"]} form-control` }
                selected={ minesQuarriesData.benefit_period_to }
                onChange={ (date) => taxContext.handleChange('parentMinesQuarries', 'mainData', 'benefit_period_to', date) }
                dateFormat="MMMM yyyy"
                locale="ar"
                disabled={ props.disabled ? true : false }
                showMonthYearPicker
                showFullMonthYearPicker
              />
              { !props.disabled && minesQuarriesDataErrors.benefit_period_to && <p className='text-danger mb-0 mt-2 me-2 fw-bolder'>{ minesQuarriesDataErrors.benefit_period_to }</p> }

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default MinesQuarries;